declare global {
	interface Window { dataLayer?: any[], adf?: { track: Function } }
}


export function trackPageView(page: string, title?: string) {
	if (window.dataLayer) {
		window.dataLayer.push({
			'event':'virtualPageView',
			'pageUrl': page,
			'title': title || ''
		});
	}
}

export function trackEvent(category: string, action: string, label?: string, value?: number) {
	if (window.dataLayer) {
		window.dataLayer.push({
			'event':'genericEvent',
			'eventCategory': category,
			'eventAction': action,
			'eventLabel': label || undefined,
			'eventValue': value || undefined
		});
	}
}

export function trackStep(step: number, params: any) {
	if (!params)
		params = {};

	var path = params.path ? params.path : '/step' + step;
	trackPageView(path, 'Step ' + step);

	adfTrack(clickPoints[step], params);
}

export function trackBeginCheckout(departureLocationName: string, arrivalLocationName: string, totalPrice: number, isReturnTrip: boolean)
{
	if (!window.dataLayer || !departureLocationName || !arrivalLocationName)
		return;

	window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
	window.dataLayer.push({
		event: "begin_checkout",
		ecommerce: {
			currency: "SEK",
			value: totalPrice,
			items: [
				{
					item_name: `${departureLocationName} - ${arrivalLocationName}, ${isReturnTrip ? "Tur och retur" : "Enkel"}`,
					price: totalPrice,
					quantity: 1,
					item_category: departureLocationName

				}
			]
		}
	});

}

interface ITransactionItem
{
	name: string;
	price: number;
	category: string;
	quantity?: number;
}

export function trackTransaction(bookingNumber: string, amount: number, tax: number, items: ITransactionItem[])
{
	if (!window.dataLayer || !items || items.length === 0)
		return;

	window.dataLayer.push({
		'event': 'transaction',
		'transactionId': bookingNumber,
		'transactionAffiliation': 'Snalltaget',
		'transactionTotal': `${amount}`,
		'transactionTax': `${tax}`,
		'transactionShipping': '0',
		'transactionCurrency': 'SEK',
		'transactionProducts': items.map(item => ({
			sku: "",
			name: item.name,
			category: item.category,
			price: item.price,
			quantity: item.quantity || 1,
			currency: "SEK"
		}))
	});

	//Ny kod för ecommerce
	window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
	window.dataLayer.push({
		event: "purchase",
		ecommerce: {
			transaction_id: bookingNumber,
			value: `${amount}`,
			tax: `${tax}`,
			shipping: 0,
			currency: "SEK",
			items: items.map(item => ({
				item_name: item.name,
				quantity: item.quantity || 1,
				price: item.price,
				item_category: item.category
			}))
		}
	});
}


const clickPoints: number[] = [];
clickPoints[1] = 4091334;
clickPoints[2] = 4091335;
clickPoints[3] = 4091336;
clickPoints[4] = 4091337;
clickPoints[5] = 4091338;

function adfTrack(p: number, params: any) {
	if (!window.adf)
		return;

	window.adf.track(192013, p, params);
}